// extracted by mini-css-extract-plugin
module.exports = {"tab":"savingsHistory_tab__1lIk7","selected":"savingsHistory_selected__3RwDG"};